<template>
  <g>
    <defs>
      <path
        id="geofences-in-a"
        d="M11,0 C17.0651724,0 22,4.93387931 22,10.9990517 C22,17.0651724 17.0651724,21.9990517 11,21.9990517 C4.93482759,21.9990517 0,17.0651724 0,10.9990517 C0,4.93387931 4.93482759,0 11,0 Z M11,2.08525862 C6.08413793,2.08525862 2.0862069,6.08413793 2.0862069,10.9990517 C2.0862069,15.9149138 6.08413793,19.9137931 11,19.9137931 C15.9158621,19.9137931 19.9137931,15.9149138 19.9137931,10.9990517 C19.9137931,6.08413793 15.9158621,2.08525862 11,2.08525862 Z M11.0157414,9.84926724 L11.1405558,9.85601475 C11.714608,9.9184408 12.1631552,10.4062845 12.1631552,10.9957328 C12.1631552,11.629181 11.6482414,12.1440948 11.0157414,12.1440948 C10.3832414,12.1440948 9.86832759,11.629181 9.86832759,10.9957328 C9.86832759,10.364181 10.3832414,9.84926724 11.0157414,9.84926724 L11.0157414,9.84926724 Z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <rect
        width="24"
        height="24"
        fill="#E3E3E3"
        fill-opacity=".01"
        style="mix-blend-mode:color-burn"
      />
      <use
        :fill="currentColor"
        :opacity="opacity"
        transform="translate(1 1)"
        xlink:href="#geofences-in-a"
      />
      <path
        fill="#BABABA"
        d="M13.8588414,8.17170234 C13.8588414,9.27213902 14.7584047,10.1704547 15.8588414,10.1704547 C16.9605257,10.1704547 17.8588414,9.27213902 17.8588414,8.17170234 C17.8588414,7.070018 16.9605257,6.17295 15.8588414,6.17295 C14.7584047,6.17295 13.8588414,7.070018 13.8588414,8.17170234 Z"
      />
    </g>
  </g>
</template>

<script>
  export default {
    props: {
      currentColor: {
        type: String,
        default: 'black'
      },
      opacity: {
        type: String,
        default: '1'
      }
    }  
  }
</script>